let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("exonR")).then(() => parcelRequire('6OpPE'));